import React from 'react'
import GroupCreateContainer from '../../../Components/Group/GroupCreate'

export default function GroupCreate() {
  return (
    <div className='page-body'>
        <GroupCreateContainer/>
    </div>
  )
}